import Sidebar from 'component/Sidebar/sidebar'
import { ChatConnectionProvider } from 'context/chat-connection'
import React from 'react'
import { Outlet } from 'react-router-dom'
import { DocProvider } from './Docs/docs-context'
import Topbar from 'component/Sidebar/topbar'
import { useSSO } from 'context/sso'

function AdminLayout() {
  const { sso } = useSSO()

  return (
    <ChatConnectionProvider>
      <DocProvider>
        {!sso ? <Sidebar /> : <Topbar />}
        <main
          className={` ${!sso ? 'sm:ml-[292px] md:w-[calc(100vw-329px)]' : ''}`}
        >
          <div className='pt-5 mt-[67px]'>
            <div
              style={{
                borderRadius: '0px 0px 20px 20px ',
                minHeight: 'calc(100vh - 100px)',
              }}
              className='p-4  bg-white'
            >
              <Outlet />
            </div>
          </div>
        </main>
      </DocProvider>
    </ChatConnectionProvider>
  )
}

export default AdminLayout
